import { render, staticRenderFns } from "./ActiveAppointmentsTable.vue?vue&type=template&id=17ddcaa0&scoped=true"
import script from "./ActiveAppointmentsTable.vue?vue&type=script&lang=js"
export * from "./ActiveAppointmentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ddcaa0",
  null
  
)

export default component.exports